import { IPaginationProps } from '../pagination/Pagination';
import { IDropdownMenuCardOption } from '../dropdown/DropdownMenuCard';
import { EditorService } from '../../services/editor';

export type TableCellValue = string | number | boolean | null;

export interface ITableRowDataPoint {
	value: string | null;
}

export enum TableColumnType {
	String = 'string',
	UUID = 'uuid',
	Number = 'number',
	Boolean = 'boolean',
	Date = 'date',
	Relation = 'relation'
}

export interface ITableColumn extends ITableRowDataPoint {
	label: string;
	sortable: boolean;
	sort: 'asc' | 'desc' | null;
	searchable: boolean;
	hidden: boolean;
	editable: boolean;
	type: TableColumnType;
	primaryKey: boolean;
	foreignKey: null | {
		table: string;
		key: string;
	};
	dataTypeLabel?: string;
	nullable?: boolean;
}

export interface ITableColumnUI extends ITableColumn {
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export interface ITableRow {
	data: ITableRowDataPoint[];
	onSelect?: (value: string) => void;
	menuOptions?: IDropdownMenuCardOption[];
}

export interface ICallbackValueEntry {
	column: string;
	value: TableCellValue;
}

export type ICallbackValues = ICallbackValueEntry[];

export interface ITableSearch {
	column: string;
	value: string;
}

export enum TableSortType {
	ASC = 'asc',
	DESC = 'desc'
}

export interface ITableSort {
	column: string;
	direction: TableSortType;
}

export type IndexedTableRowSelection = {
	index: number;
};

export type PrimaryKeyTableRowSelection = {
	primaryKey: string | number;
};

export type TableRowSelection =
	| IndexedTableRowSelection
	| PrimaryKeyTableRowSelection;

export interface ITableProps {
	project?: EditorService;
	totalItems?: number;
	emptyMessage?: string;
	hideCreate?: boolean;
	hideSelection?: boolean;
	hideRowActions?: boolean;
	hideDelete?: boolean;
	footerHelperText?: string;
	columns: ITableColumnUI[];
	rows: ITableRow[];
	loading?: boolean;
	pagination?: IPaginationProps;
	searches?: ITableSearch[];
	sorts?: ITableSort[];
	selection?: TableRowSelection[];
	tableKey: string;
	onCreate?: (values: ICallbackValues) => any;
	onUpdate?: (values: ICallbackValues) => any;
	onDelete?: (value: TableRowSelection) => any;
	onDeleteMany?: (values: TableRowSelection[]) => any;
	onDeleteAll?: () => any;
	onSearch?: (column: string, value: string) => any;
	onSearchesUpdate?: (searches: ITableSearch[]) => any;
	onSort?: (column: string, direction: TableSortType) => any;
	onSortsUpdate?: (sorts: ITableSort[]) => any;
	onSelection?: (entries: TableRowSelection[]) => any;
}
